import { motion } from "framer-motion";
import { STATS } from "@/constants/testIds";

const stats = [
  { label: "Established", value: "1996", suffix: "", testid: STATS.itemEstablished },
  { label: "Years Vertical", value: "28+", suffix: "yrs", testid: STATS.itemYears },
  { label: "Units Serviced", value: "500+", suffix: "in GTA", testid: STATS.itemUnits },
  { label: "Response Time", value: "60", suffix: "min · 24/7", testid: STATS.itemResponse },
];

export default function Stats() {
  return (
    <section
      data-testid={STATS.root}
      className="bg-[#0A0A0A] text-white border-b border-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            data-testid={s.testid}
            className={`px-6 md:px-10 py-10 md:py-14 ${
              i !== 0 ? "md:border-l" : ""
            } ${i >= 2 ? "border-t md:border-t-0" : ""} ${
              i % 2 === 1 ? "border-l" : ""
            } border-white/15`}
          >
            <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/50">
              {s.label}
            </div>
            <div className="mt-4 flex items-baseline gap-3">
              <span className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-none tracking-tighter">
                {s.value}
              </span>
              {s.suffix && (
                <span className="text-xs md:text-sm font-medium uppercase tracking-widest text-white/60">
                  {s.suffix}
                </span>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
